import { isNewOrderSecurity } from '@src/components/OMS/NewOrder/utils';
import { ProductTypeEnum, type Security } from '@talos/kyoko';

export interface ManualTradeProductFlags {
  enableGovernmentBonds: boolean;
  enableShares: boolean;
}

/**
 * Whether a security can be booked on the Manual Trade form.
 *
 * Manual Trade books fills, including products that are not OMS-orderable.
 * Share and GovernmentBond are allowed when their feature flags are on.
 * Every other product type follows {@link isNewOrderSecurity} (OTC / Loan and
 * STS digital options stay excluded).
 *
 * Do not use this for New Order — that is {@link isNewOrderSecurity}.
 */
export function isManualTradeSecurity(security: Security, flags: ManualTradeProductFlags): boolean {
  if (security.ProductType === ProductTypeEnum.GovernmentBond) {
    return flags.enableGovernmentBonds;
  }

  if (security.ProductType === ProductTypeEnum.Share) {
    return flags.enableShares;
  }

  return isNewOrderSecurity(security);
}

/**
 * Filters `searchableSecurities` to those allowed on the Manual Trade form.
 * See {@link isManualTradeSecurity}.
 */
export function getManualTradeSearchableSecurities(
  searchableSecurities: Security[],
  flags: ManualTradeProductFlags
): Security[] {
  return searchableSecurities.filter(security => isManualTradeSecurity(security, flags));
}
